export default __webpack_public_path__ + "static/media/q_wdt_c_4_5.ad781e62.mp3";